import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Row, Col } from 'antd'
import '../../css/regimen.scss'
import { useLocation } from 'react-router'
import { getRegimens } from '../../store/action/regimen.action'
import RegimenCard from './regimen.card'
import leftArrow from '../../images/arrow_left.svg'
import rightArrow from '../../images/arrow_right.svg'
import { useWindowsSize } from '..'
import _ from 'lodash'

const RegimenList = (props) => {
  const ref = useRef(null)
  var location = useLocation()
  var patient = location.state
  var size = useWindowsSize()
  const [limit, setLimit] = useState(1)
  const [offset, setOffset] = useState(0)

  var shiftRight = () => setOffset(limit + offset)
  var shiftLeft = () => setOffset(offset - limit)

  useEffect(() => {
    var wdth = ref.current ? ref.current.offsetWidth : 0
    setLimit(Math.floor(wdth / 280))
  }, [ref.current, size.width])

  useEffect(() => {
    props.fetchRegimens((props.filters && Object.keys(props.filters).length > 0)? {...props.filters} : {filter:{},companyid:props.customer.company,customerid:props.customer._id})
  }, [])

  useEffect(() => {
    setOffset(0)
  }, [props.filters])

  var renderCards = () => {
    return props.regimens
      ? props.regimens.map((regimen, index) => {
          var assigned =
            _.findIndex(props.assignedRegs, { _id: regimen._id }) != -1
          return index >= offset && index <= offset + limit - 1 ? (
            <RegimenCard regimen={regimen} assigned={assigned} />
          ) : null
        })
      : null
  }

  console.log(offset, props.regimens?.length)

  return (
    <Row className='filterListContainer'>
      <Col flex={'25px'}>
        <img
          hidden={offset + 1 - limit <= 0}
          onClick={shiftLeft}
          className='arrowIcon'
          src={rightArrow}
          height={35}
          width={24}
        />
      </Col>
      <Col style={{ width: '100%' }} flex={'auto'}>
        <div ref={ref} style={{ height: '100%' }}>
          <Row style={{ height: '100%' }} justify='space-around' align='middle'>
            {renderCards()}
          </Row>
        </div>
      </Col>
      <Col flex={'25px'}>
        <img
          hidden={offset + limit >= props.regimens?.length}
          onClick={shiftRight}
          className={'arrowIcon'}
          src={leftArrow}
          height={35}
          width={24}
        />
      </Col>
    </Row>
  )
}

RegimenList.propTypes = {
  company: PropTypes.object,
  regimens: PropTypes.object,
}

const mapStateToProps = (state) => {
  return {
    company: state.profile.company,
    regimens: state.regimen.regimens,
    assignedRegs: state.regimen.assignedRegs,
    filters: state.regimen.filters,
    customer:state.profile.customer
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchRegimens: (filter) => dispatch(getRegimens(filter)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RegimenList)
